import React, { useState } from "react";
import PropTypes from "prop-types";
import "./examinationCard.scss";
import Skeleton from "@mui/material/Skeleton";
import FilterListIcon from '@mui/icons-material/FilterList';
import FilterBadge from "../common/FilterBadge";

const ExaminationCard = ({ type, value, icon, loading = false, appliedFilters = [] }) => {
    const [showFilters, setShowFilters] = useState(false);
    const hasFilters = appliedFilters.length > 0 && !loading;

    return (
        <div
            className={`examinationCard ${hasFilters ? 'has-filters' : ''}`}
            onMouseEnter={() => setShowFilters(true)}
            onMouseLeave={() => setShowFilters(false)}
        >
            <div className="left">
                <div className="title-row">
                    <span className="title" aria-label={`Type: ${type}`}>
                        {type}
                    </span>
                    {hasFilters && (
                        <div className="filter-indicator">
                            <FilterListIcon fontSize="small" />
                        </div>
                    )}
                </div>

                {loading ? (
                    <Skeleton
                        variant="text"
                        width={80}
                        height={40}
                        animation="wave"
                    />
                ) : (
                    <span className="counter" aria-label={`Value: ${value}`}>
                        {value}
                    </span>
                )}
            </div>
            <div className="right">
                <span className="icon">
                    {loading ? (
                        <Skeleton
                            variant="circular"
                            width={40}
                            height={40}
                            animation="wave"
                        />
                    ) : (
                        icon
                    )}
                </span>
            </div>

            {hasFilters && showFilters && (
                <div className="filter-tooltip">
                    <div className="filter-header">Applied Filters:</div>
                    <div className="filter-badges">
                        {appliedFilters.map((filter, index) => (
                            <FilterBadge
                                key={index}
                                label={filter.label}
                                value={filter.value}
                            />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

ExaminationCard.propTypes = {
    type: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    icon: PropTypes.element.isRequired,
    loading: PropTypes.bool,
    appliedFilters: PropTypes.array
};

export default ExaminationCard;